import React from 'react';
import './Experience.css'


const Experience = () => {
    return (  
        <div className = "experience" id = 'Experiences'>
        <div className = "achievment">
            <div className = "circle" >2+</div>
            <span>Experience</span>
            <br />
            <span>years</span>
        </div>
        <div className = "achievment">
            <div className = "circle">2+</div>
             <span>Completed</span>
             <br />
             <span>Projects</span>
        </div>
        <div className = "achievment">
            <div className = "circle">1</div>
             <span>Companies</span>
             <br />
             <span>worked</span>
        </div>


        </div>
    )
}
 
export default Experience